var React = require('react');

function SurveyRegionName (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M32,19.91C32,23.08,27,27,27,27s-5-9.74-5-12.91,2.24-4.45,5-2.85A11,11,0,0,1,32,19.91Z","key":0}),React.createElement("polygon",{"points":"18.02 23.98 4.26 16.03 4.26 0.23 18.02 8.18 18.02 23.98","fill":"#a4c2ea","key":1}),React.createElement("polygon",{"points":"28.84 49.93 4.26 36.4 4.26 20.6 28.84 34.13 28.84 49.93","fill":"#72a6ea","key":2}),React.createElement("polygon",{"points":"42.45 45.63 33.77 40.7 33.77 24.9 42.45 29.83 42.45 45.63","fill":"#dce0f1","key":3})]);
}

SurveyRegionName.defaultProps = {"id":"Layer_1","data-name":"Layer 1","viewBox":"0 0 50 50"};

module.exports = SurveyRegionName;

SurveyRegionName.default = SurveyRegionName;
